import React from 'react';
import type { PopoverProps } from '@mui/material/Popover';
import type { SlideProps } from '@mui/material/Slide';

import { useNotificationsCtx } from '../../model';

import NotificationsDrawerPopover from './notifications-drawer-popover';
import type { DragDirection } from './types';

type NotificationsDrawerPopoverContainerProps = {
  className?: string;
  direction: DragDirection;
} & Pick<SlideProps, 'container'> &
  Pick<PopoverProps, 'anchorEl'>;

const NotificationsDrawerPopoverContainer = (
  props: React.PropsWithChildren<NotificationsDrawerPopoverContainerProps>
) => {
  const { notificationType } = useNotificationsCtx();

  const isUrgent = notificationType === 'urgent';

  return <NotificationsDrawerPopover {...props} isUrgent={isUrgent} />;
};

export default NotificationsDrawerPopoverContainer;
